/*eslint-disable unused-imports/no-unused-vars*/
import axios from '@axios'
import { defineStore } from '@core/utils/vuex'

export default defineStore({
    namespaced: true,
    state: {
        bancoProveedor: [],
        cargarProveedor: [],
        agregarProveedor: [],
        proveedorById: [],
        proveedor: [],
        solicitudProveedor: [],
        entidad: [],
        entidadById: [],
        tipoIdentificacion: [],
        categoria: [],
        estadoCivil: [],
        genero: [],
        permisoCategoria: [],
        plazoPago: [],
    },
    getters: {
        getBancoProveedor(state) {
            return state.bancoProveedor
        },

        getCargarProveedor(state) {
            return state.cargarProveedor
        },

        getProveedorById(state) {
            return state.proveedorById
        },

        getProveedor(state) {
            return state.proveedor
        },

        getSolicitudProveedor(state) {
            return state.solicitudProveedor
        },

        getEntidad(state) {
            return state.entidad
        },

        getTipoIdentificacion(state) {
            return state.tipoIdentificacion
        },

        getCategoria(state) {
            return state.categoria
        },

        getEstadoCivil(state) {
            return state.estadoCivil
        },

        getGenero(state) {
            return state.genero
        },

        getEntidadById(state) {
            return state.entidadById
        },

        getPermisoCategoria(state) {
            return state.permisoCategoria
        },

        getPlazoPago(state) {
            return state.plazoPago
        },
    },
    mutations: {
        setBancoProveedor(state, bancoProveedor) {
            state.bancoProveedor = bancoProveedor
        },

        setCargarProveedor(state, cargarProveedor) {
            state.cargarProveedor = cargarProveedor
        },

        setProveedorById(state, proveedorById) {
            state.proveedorById = proveedorById
        },

        setProveedor(state, proveedor) {
            state.proveedor = proveedor
        },

        setSolicitudProveedor(state, solicitudProveedor) {
            state.solicitudProveedor = solicitudProveedor
        },

        setEntidad(state, entidad) {
            state.entidad = entidad
        },

        setTipoIdentificacion(state, tipoIdentificacion) {
            state.tipoIdentificacion = tipoIdentificacion
        },

        setCategoria(state, categoria) {
            state.categoria = categoria
        },

        setEstadoCivil(state, estadoCivil) {
            state.estadoCivil = estadoCivil
        },

        setGenero(state, genero) {
            state.genero = genero
        },

        setEntidadById(state, entidadById) {
            state.entidadById = entidadById
        },

        setPermisoCategoria(state, permisoCategoria) {
            state.permisoCategoria = permisoCategoria
        },

        setPlazoPago(state, plazoPago) {
            state.plazoPago = plazoPago
        },
    },
    actions: {
        fetchProveedor({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/personas/proveedor', {
                        params: {
                            search: data?.search,
                            cedula: data?.cedula,
                            pais: data?.pais,
                            ciudad: data?.ciudad,
                            tipoEntidad: data?.tipoEntidad,
                            ...data,
                            page: data?.paginated ? data?.page : undefined,
                            per_page: data?.paginated ? data.per_page : undefined,
                            paginated: Number(data?.paginated ?? 0),
                        },
                    })
                    .then(response => {
                        commit('setCargarProveedor', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchBancoProveedor({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/personas/banco')
                    .then(response => {
                        commit('setBancoProveedor', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAgregarProveedor({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/v2/personas/proveedor/agregar-proveedor', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchProveedorById({ commit }, id_proveedor) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/personas/proveedor/${id_proveedor}`)
                    .then(response => {
                        commit('setProveedorById', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEditarProveedor({ commit }, { id_proveedor, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm(`/api/auth/v2/personas/proveedor/${id_proveedor}`, {
                        ...data,
                        _method: 'PUT',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEliminarProveedor({ commit }, id_proveedor) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/personas/proveedor/${id_proveedor}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSolicitudProveedor({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/personas/registro', {
                        params: {
                            nombre_prov: data?.nombre_prov,
                            numero_identificacion: data?.numero_identificacion,
                            pais: data?.pais,
                            ciudad: data?.ciudad,
                            tipoEntidad: data?.tipoEntidad,
                            ...data,
                            page: data?.paginated ? data.currentPage : undefined,
                            perPage: data?.paginated ? data.perPage : undefined,
                            paginated: Number(data?.paginated ?? 0),
                        },
                    })
                    .then(response => {
                        commit('setSolicitudProveedor', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAprobarProveedor({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('api/auth/v2/personas/registro/aprobar-proveedor', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.log(error)
                    })
            })
        },

        // fetchEntidades({ commit }, data) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .get('/api/auth/v2/personas/entidad', {
        //                 params: {
        //                     entidad: data?.entidad,
        //                     identificacion: data?.identificacion,
        //                     pais: data?.pais,
        //                     ciudad: data?.ciudad,
        //                     tipoEntidad: data?.tipoEntidad,
        //                     ...data,
        //                     page: data?.paginated ? data.currentPage : undefined,
        //                     perPage: data?.paginated ? data.perPage : undefined,
        //                     paginated: Number(data?.paginated ?? 0),
        //                 },
        //             })
        //             .then(response => {
        //                 commit('setEntidad', response.data)
        //                 resolve(response.data)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },

        fetchEntidades({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/personas/entidad', { params: data })
                    .then(response => {
                        commit('setEntidad', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //crear entidad
        postCrearEntidades({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/v2/personas/entidad/agregar-entidad', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEntidadById({ commit }, id_entidad) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/personas/entidad/${id_entidad}`)
                    .then(response => {
                        commit('setEntidadById', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTipoIdentificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/personas/identificacion', {
                        params: {
                            ...data,
                            page: data?.paginated ? data.currentPage : undefined,
                            perPage: data?.paginated ? data.perPage : undefined,
                            paginated: Number(data?.paginated ?? 0),
                        },
                    })
                    .then(response => {
                        commit('setTipoIdentificacion', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCategorias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/personas/categoria', {
                        params: {
                            with_permisos: data?.permiso,
                            tipo_entidad: data?.tipo_entidad,
                            ...data,
                            page: data?.paginated ? data.currentPage : undefined,
                            perPage: data?.paginated ? data.perPage : undefined,
                            paginated: Number(data?.paginated ?? 0),
                        },
                    })
                    .then(response => {
                        commit('setCategoria', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEstadoCivil({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/personas/entidad/estado-civil')
                    .then(response => {
                        commit('setEstadoCivil', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchGenero({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/personas/entidad/genero')
                    .then(response => {
                        commit('setGenero', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAgregarEntidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/v2/personas/entidad/agregar-entidad', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAlternarEstado({ commit }, id_entidad) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/personas/entidad/${id_entidad}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEditarEntidad({ commit }, { id_entidad, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/personas/entidad/${id_entidad}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisoCategoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/personas/permiso', {
                        params: {
                            usuario: data?.usuario,
                            categorias: data?.categorias,
                            ...data,
                            page: data?.paginated ? data.currentPage : undefined,
                            per_page: data?.paginated ? data.per_page : undefined,
                            paginated: Number(data?.paginated ?? 0),
                        },
                    })
                    .then(response => {
                        commit('setPermisoCategoria', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAgregarPermiso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/v2/personas/permiso/agregar-permiso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEditarPermiso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/personas/permiso`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchActualizarRegistroProveedor({ commit }, { id_proveedor, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm(`/api/auth/v2/personas/registro/${id_proveedor}`, {
                        ...data,
                        _method: 'PUT',
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
})
